import { TemplateRef } from '@angular/core';

export enum OrderStatuses {
  OPEN = 'OPEN',
  IN_PROCESS = 'INPROCESS',
  COMPLETED = 'COMPLETED',
  CREDIT_HOLD = 'CREDIT_HOLD',
  DUPLICATE_HOLD = 'DUPLICATE_HOLD',
  DELIVERY_HOLD = 'DELIVERY_HOLD',
  CANCELLED = 'CANCELLED',
}

export interface OrderPaymentInfo {
  accountHolderName: string;
  ach: boolean;
  addPaymentDetails: boolean;
  cardNumber: string;
  cardType: {
    code: string;
    name: string;
  };
  defaultPayment: boolean;
  defaultPaymentInfo: boolean;
  deletePaymentDetails: boolean;
  expiryMonth: string;
  expiryYear: string;
  id: string;
  savePaymentDetails: boolean;
  saved: boolean;
  updatePaymentDetails: boolean;
}

export interface OrderCappingToast {
  template: TemplateRef<any>;
  classname?: string;
  delay?: number;
}
